import { render, staticRenderFns } from "./insurance-introduction.vue?vue&type=template&id=5445524a&scoped=true&"
import script from "./insurance-introduction.vue?vue&type=script&lang=js&"
export * from "./insurance-introduction.vue?vue&type=script&lang=js&"
import style0 from "./insurance-introduction.vue?vue&type=style&index=0&id=5445524a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5445524a",
  null
  
)

export default component.exports